var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#28BFD7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.238,
    y: 44.6692,
    width: 34.2132,
    height: 2.5034,
    fill: "#010101"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.907,
    y: 41.3313,
    width: 30.8753,
    height: 2.5034,
    fill: "#010101"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2449,
    y: 40.4969,
    width: 17.5238,
    height: 6.67574,
    transform: "rotate(-90 20.2449 40.4969)",
    fill: "#010101"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4241,
    y: 40.4969,
    width: 17.5238,
    height: 6.67574,
    transform: "rotate(-90 29.4241 40.4969)",
    fill: "#010101"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.603,
    y: 40.4969,
    width: 17.5238,
    height: 6.67574,
    transform: "rotate(-90 38.603 40.4969)",
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1538 18.8007L17.7415 18.6015C17.9383 16.7083 18.8898 15.1723 20.596 13.9932C22.3241 12.7976 24.4021 12.1997 26.8301 12.1997C28.252 12.1997 29.4878 12.3907 30.5378 12.7726C31.5878 13.1546 32.5612 13.5947 33.458 14.0928C34.3548 14.5744 35.2626 15.0145 36.1813 15.413C37.1219 15.795 38.1937 15.986 39.3968 15.986C40.7968 15.986 42.0654 15.6289 43.2029 14.9149C44.3404 14.1842 45.0185 13.2542 45.2372 12.125L48.6167 12.5236C48.2886 14.4001 47.2496 15.9029 45.4997 17.0322C43.7716 18.1614 41.7811 18.726 39.5281 18.726C38.0844 18.726 36.8594 18.535 35.8532 18.1531C34.8689 17.7711 33.9502 17.3394 33.0971 16.8578C32.244 16.3596 31.3471 15.9195 30.4066 15.5376C29.466 15.139 28.3176 14.9398 26.9614 14.9398C25.4083 14.9398 24.0849 15.3134 22.9912 16.0607C21.8975 16.7914 21.2851 17.7047 21.1538 18.8007Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.b38a1d92be32943930a57a3562c448c8.svg";
export { ForwardRef as ReactComponent };